import { apiClient } from './api';

export interface Kiosk {
  id: string;
  name: string;
  deviceId: string | null;
  isActive: boolean;
  pairedAt: string;
  lastHeartbeat: string | null;
}

export interface PairingCode {
  code: string;
  expiresAt: string;
}

interface ListResponse {
  success: boolean;
  data: Kiosk[];
}

interface PairingCodeResponse {
  success: boolean;
  data: PairingCode;
}

interface RevokeResponse {
  success: boolean;
  data: { kioskId: string; revoked: boolean };
}

export const kioskService = {
  list: async (): Promise<Kiosk[]> => {
    const res = await apiClient.get<ListResponse>('/kiosks');
    return res.data;
  },

  generatePairingCode: async (): Promise<PairingCode> => {
    const res = await apiClient.post<PairingCodeResponse>('/kiosks/pairing-codes');
    return res.data;
  },

  revoke: async (kioskId: string): Promise<void> => {
    await apiClient.post<RevokeResponse>(`/kiosks/${kioskId}/revoke`);
  },
};

export type KioskStatus = 'online' | 'idle' | 'offline' | 'revoked';

export const deriveStatus = (k: Kiosk, now = Date.now()): KioskStatus => {
  if (!k.isActive) return 'revoked';
  if (!k.lastHeartbeat) return 'offline';
  const age = now - new Date(k.lastHeartbeat).getTime();
  if (age < 5 * 60 * 1000) return 'online';
  if (age < 30 * 60 * 1000) return 'idle';
  return 'offline';
};
